import { render, staticRenderFns } from "./FieldDiscountEditor.vue?vue&type=template&id=18729084&scoped=true"
import script from "./FieldDiscountEditor.vue?vue&type=script&lang=js"
export * from "./FieldDiscountEditor.vue?vue&type=script&lang=js"
import style0 from "./FieldDiscountEditor.vue?vue&type=style&index=0&id=18729084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18729084",
  null
  
)

export default component.exports